import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { License } from 'src/types/licenses';
import {
  EndpointData,
  setStateData,
  setStateError,
  setStateLoading,
} from 'src/types/store';

export interface UserLicensesState {
  userLicenses: EndpointData<License>;
  renewableLicenses: EndpointData<License>;
}

const INITIAL_STATE: UserLicensesState = {
  userLicenses: {
    nextContToken: 0,
    contToken: -1,
    data: [],
    loading: false,
    pagesLoaded: [],
  },
  renewableLicenses: {
    nextContToken: 0,
    contToken: -1,
    data: [],
    loading: false,
    pagesLoaded: [],
  },
};

export const userLicensesSlice = createSlice({
  name: 'userLicenses',
  initialState: INITIAL_STATE,
  reducers: {
    setUserLicensesLoading: (state, action: PayloadAction<boolean>) => {
      state.userLicenses = setStateLoading(state.userLicenses, action.payload);
    },
    setUserLicenses: (state, action) => {
      state.userLicenses = setStateData(state.userLicenses, action);
    },
    setUserLicensesFailure: (state, action) => {
      state.userLicenses = setStateError(state.userLicenses, action);
    },
    setRenewableLicensesLoading: (state, action) => {
      state.renewableLicenses = setStateLoading(
        state.renewableLicenses,
        action.payload
      );
    },
    setRenewableLicenses: (state, action) => {
      state.renewableLicenses = setStateData(state.renewableLicenses, action);
    },
    setRenewableLicensesFailure: (state, action) => {
      state.renewableLicenses = setStateError(state.renewableLicenses, action);
    },
    resetRenewableUserLicencesState: (state) => {
      state.renewableLicenses = INITIAL_STATE.renewableLicenses;
    },
  },
});

export const {
  setUserLicensesLoading,
  setUserLicenses,
  setRenewableLicensesLoading,
  setRenewableLicenses,
  setUserLicensesFailure,
  setRenewableLicensesFailure,
  resetRenewableUserLicencesState,
} = userLicensesSlice.actions;

export default userLicensesSlice.reducer;
